<!-- <!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="stylesheet" href="css/utils.css">
    <link rel="stylesheet" href="css/style.css">
    <link rel="stylesheet" href="css/mobile.css">
    <title>iBlog - Heaven for bloggers</title>
</head>
<body>
    <nav class="navigation max-width-1 m-auto">
        <div class="nav-left">
            <a href="/">
                <span><img src="img/logo.png" width="94px" alt=""></span>
            </a>
            <ul>
                <li><a href="/">Home</a></li>
                <li><a href="#">About</a></li>
                <li><a href="/contact.html">Contact</a></li>
            </ul>
        </div>
        <div class="nav-right">
            <form action="/search.html" method="get">
                <input class="form-input" type="text" name="query" placeholder="Article Search">
                <button class="btn">Search</button>
            </form>

        </div>

    </nav>
 

    <div class="max-width-1 m-auto"><hr></div>
    <div class="home-articles max-width-1 m-auto font2">
        
        <h2>Search Results for Django (0.03 seconds)</h2>
        <div class="year-box adjust-year">
            <div>
                <h3>Year </h3>
            </div>
            <div>
                <input type="radio" name="year" id=""> 2020
            </div>
            <div>
                <input type="radio" name="year" id=""> 2021
            </div>
            <div>
                <input type="radio" name="year" id=""> 2022
            </div>
            <div>
                <input type="radio" name="year" id=""> 2023
            </div>
        </div>
        <div class="home-article">
            <div class="home-article-img">
                <img src="img/11.svg" alt="article">
            </div>
            <div class="home-article-content font1">
                <a href="/blogpost.html"><h3>The Future of Work: How AI and Automation are Changing the Job Landscape</h3></a>
                
                <span>Byomkesh Mahato</span>
                <span>07 January | 6 min read</span>
            </div>
        </div>
        <div class="home-article">
            <div class="home-article-img">
                <img src="img/11.svg" alt="article">
            </div>
            <div class="home-article-content font1">
                <a href="/blogpost.html"><h3>The Psychology of Procrastination: Understanding Why We Delay and How to Overcome It</h3></a>
                
                <span>Byomkesh Mahato</span>
                <span>04 February | 4 min read</span>
            </div>
        </div>
        <div class="home-article">
            <div class="home-article-img">
                <img src="img/11.svg" alt="article">
            </div>
            <div class="home-article-content font1">
                <a href="/blogpost.html"><h3>10 Ways to Improve Your Mental Health and Well-Being</h3></a>
                
                <span>Byomkesh Mahato</span>
                <span>08 March | 5 min read</span>
            </div>
        </div>
        <div class="home-article">
            <div class="home-article-img">
                <img src="img/home.svg" alt="article">
            </div>
            <div class="home-article-content font1">
                <a href="/blogpost.html"><h3>Why Mindfulness Matters: The Benefits of Practicing Mindfulness in Your Daily Life</h3></a>
                
                <span>Byomkesh Mahato</span>
                <span>03 April | 6 min read</span>
            </div>
        </div>
        <div class="home-article">
            <div class="home-article-img">
                <img src="img/11.svg" alt="article">
            </div>
            <div class="home-article-content font1">
                <a href="/blogpost.html"><h3>The Power of Positive Thinking: How Optimism Can Improve Your Life</h3></a>
                
                <span>Byomkesh Mahato</span>
                <span>05 May | 4 min read</span>
            </div>
        </div>
        <div class="home-article">
            <div class="home-article-img">
                <img src="img/11.svg" alt="article">
            </div>
            <div class="home-article-content font1">
                <a href="/blogpost.html"><h3>Navigating the Job Market: Tips for Finding Your Dream Job</h3></a>
                
                <span>Byomkesh Mahato</span>
                <span>21 June | 3 min read</span>
            </div>
        </div>
        <div class="home-article">
            <div class="home-article-img">
                <img src="img/11.svg" alt="article">
            </div>
            <div class="home-article-content font1">
                <a href="/blogpost.html"><h3>The Benefits of Learning a Second Language: Why Bilingualism is Good for Your Brain and Your Career</h3></a>
                
                <span>Byomkesh Mahato</span>
                <span>16 July | 4 min read</span>
            </div>
        </div>
        <div class="home-article">
            <div class="home-article-img">
                <img src="img/11.svg" alt="article">
            </div>
            <div class="home-article-content font1">
                <a href="/blogpost.html"><h3>The Ethics of AI: Exploring the Social and Moral Implications of Artificial Intelligence</h3></a>
                
                <span>Byomkesh Mahato</span>
                <span>08 August | 6 min read</span>
            </div>
        </div>
         
    </div>

    <div class="footer">
        <p>Copyright &copy; iBlog.com </p>
         <a href="https://www.vecteezy.com/free-vector/typewriter">Vector Credits: Vecteezy</a> 
    </div>
</body>
</html> -->

SEARCH